import BaseRepository from './base-repository';
import wait from './operation-helper';

import { Attachment, AttachmentIdentifier } from '@/types/Attachment';

export default class BaseAttachmentRepository extends BaseRepository<Attachment> {
  public async uploadAttachment(file: File, kind: AttachmentIdentifier) {
    const op = await this._upload<Attachment>(file, '', { kind }, 'PUT');
    return wait<Attachment>(op);
  }
}
